module.exports = __webpack_public_path__ + "img/fittingBG.16f2359f.png";